// Resolve a libationScan row's photo to a CDN URL. Mirrors the client-side
// helper in client/src/components/WineMediaStrip.js — admin needs the same
// behaviour because some legacy scans store the raw S3 URL on `photoUrl`
// while newer scans carry a `photoWebpUrl` pre-built against the CDN.
// Either way we end up with a CDN-served WebP that the resize lambda can
// rewrite with size params on demand.

const ATTACHMENT_URL = process.env.REACT_APP_ATTACHMENT_URL;

const scanAssetUrl = (scan, queryString = '?w=400&h=400&f=inside&q=85') => {
  const raw = scan?.photoWebpUrl || scan?.photoUrl;
  if (!raw || !ATTACHMENT_URL) return null;
  const noQuery = raw.split('?')[0];
  const s3Split = noQuery.split('.amazonaws.com/');
  const key = s3Split.length === 2
    ? s3Split[1]
    : (noQuery.split(`${ATTACHMENT_URL}/`)[1] || noQuery);
  return `${ATTACHMENT_URL}/${key}${queryString}`;
};

export default scanAssetUrl;
